'use strict';
(function () {
  angular.module('pentaApp').factory('profile.resource', service);

  service.$inject = ['resourceHelper.factory'];
  function service(resourceHelper) {
    return resourceHelper.defaultResource('/progressiveApp/api/profile')
  }
})();
